const addAPPMessageBox = (insertBeforeElement) => {
  if (!document.querySelector(`[id^="appLoginLinkPinpoll"]`)) {
    let appLoginLink = document.createElement('a')
    const appLoginDiv = document.createElement('div')
    appLoginLink.href = 'https://www.stol.it/anmelden?callBack=checkPinPollLogin'
    appLoginLink.id = 'appLoginLinkPinpoll'
    appLoginDiv.innerHTML =
      'Bitte <strong>registrieren / anmelden</strong>,<br>damit Sie das Ergebnis<br>der Umfrage sehen können.'
    const appLoginLinkStyle = `
              text-decoration: none;
              border: 2px solid #999999;
              background-color: #e2e2e2;
              height: 350px;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              padding: 10px;
              color: rgba(51, 51, 51, 1);
            `
    appLoginLink.style = appLoginLinkStyle
    appLoginLink.appendChild(appLoginDiv)
    insertBeforeElement.parentNode.insertBefore(appLoginLink, insertBeforeElement)
  }
}

export default addAPPMessageBox
